import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-toggle2-on",
  "use": "icon-toggle2-on-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" class=\"bi bi-toggle2-on\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-toggle2-on\">\r\n  <path d=\"M7 5H3a3 3 0 0 0 0 6h4a4.995 4.995 0 0 1-.584-1H3a2 2 0 1 1 0-4h3.416c.156-.357.352-.692.584-1z\" />\r\n  <path d=\"M16 8A5 5 0 1 1 6 8a5 5 0 0 1 10 0z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/toggle2-on.svg
// module id = O5di
// module chunks = 60